import advanceReportingConstants from "@/constants/advanceReportingConstants"
import passConstants from "@/constants/passConstants"

const state = {
  activeRoute: null
}
const getters = {
  isVisibleTardyManagment(state, getters, rootState, rootGetters) {
    return rootGetters["schools/isCurrentUserHasAccessToTardyManagment"]
  },
  isStudentLadderVisible(state, getters, rootState, rootGetters) {
    return (
      Boolean(
        rootGetters["schools/tardyManagementOptions"]?.[
          "allow-students-see-level"
        ]
      ) && !!rootGetters["consequencesLadder/ladderTypes"]?.length
    )
  },
  isVisibleTardyAdults(state, getters, rootState, rootGetters) {
    return !!rootGetters["schools/tardyManagementOptions"]?.[
      "allow-selected-users-only"
    ]
  },
  isVisibleTardyCSVUpload() {
    return true
  },
  isVisibleTardyCSVUploadHeaderAction(
    _state,
    _getters,
    _rootState,
    rootGetters
  ) {
    const fileUploadMode =
      rootGetters?.["schools/tardyManagementOptions"]?.["file-upload-mode"] ||
      passConstants.DEFAULT_FILE_UPLOAD_MODE_FOR_TARDY
    return fileUploadMode === "manual"
  },
  activeRoute(state) {
    return state.activeRoute
  },
  hasVisitorSettingsRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorAdultListRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorListSettingsRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorGuardianStudentMatrixRouteAccess(
    _state,
    _getters,
    _rootState,
    rootGetters
  ) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorSecuritySettingsRouteAccess(
    _state,
    _getters,
    _rootState,
    rootGetters
  ) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorKioskSettingsRouteAccess(
    _state,
    _getters,
    _rootState,
    rootGetters
  ) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorGeneralSettingsRouteAccess(
    _state,
    _getters,
    _rootState,
    rootGetters
  ) {
    return rootGetters["visitorSettings/hasVisitorSettingsAccess"]
  },
  hasVisitorManagementRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["visitorSettings/hasVisitorManagementAccess"]
  },
  hasVisitorCheckInsLogsRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["visitorSettings/hasVisitorManagementAccess"]
  },
  hasVisitorPrinterSetupRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["visitorSettings/hasVisitorManagementAccess"]
  },
  hasQueueSettingsRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["queueSettings/hasQueueSettingsAccess"]
  },
  hasAppointmentModuleRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["schools/isActiveAppoinmentModule"]
  },
  hasRetainedModuleRouteAccess(_state, _getters, _rootState, rootGetters) {
    return rootGetters["schools/isActiveRetainedModule"]
  },
  hasAdvanceReportingAccess(_state, _getters, _rootState, rootGetters) {
    const allowedSchoolIds =
      advanceReportingConstants.ADVANCE_REPORTING_ALLOWED_SCHOOL_IDS
    if (!allowedSchoolIds?.trim()) {
      // Empty = all schools
      return true
    }

    const activeSchool = rootGetters["schools/activeSchool"]
    if (!activeSchool?.id) {
      // No active school = no access
      return false
    }

    const allowedList =
      allowedSchoolIds?.split(",")?.map((id) => id?.trim()) || []
    // Check if the active school is in the allowed list
    const isAdvReportingVisible = allowedList.includes(String(activeSchool.id))
    return isAdvReportingVisible
  },
  /** Student Digital ID nav/route when Digital ID Card module disallows student device view */
  isStudentDigitalIdRouteAllowed(_state, _getters, _rootState, rootGetters) {
    if (rootGetters["authentication/getUserRole"] !== "student") {
      return true
    }
    const options = rootGetters["schools/digitalIdCardModuleOptions"]
    return !options?.restrict_student_view_id
  },
  /**
   * Behaviour Management settings: admins only, and module must be turned on (Modules page).
   */
  hasBehaviourSettingsRouteAccess(_state, _getters, _rootState, rootGetters) {
    return (
      rootGetters["behaviourSettings/hasBehaviourSettingsAccess"] &&
      rootGetters["behaviourSettings/isBehaviourModuleActive"]
    )
  }
}
const mutations = {
  SET_ACTIVE_ROUTE(state, route) {
    state.activeRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
